import { Link } from 'react-router-dom';
import IncidentCard from '@/components/base/IncidentCard';
import RiskBadge from '@/components/base/RiskBadge';
import { incidents } from '@/mocks/incidents';

export default function LatestIncidents() {
  const [featured, ...rest] = incidents;
  const others = rest.slice(0, 3);

  return (
    <section id="latest-incidents" className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
        <div className="max-w-2xl">
          <p className="text-xs font-medium tracking-[0.2em] text-primary-700">近期重点事件</p>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            已经发生过的，就是最有用的预警
          </h2>
          <p className="mt-3 text-sm leading-7 text-foreground-600">
            下面这些事件覆盖泄露、漏洞、盗刷与违规收集，每一篇都包含可执行的应对建议。
          </p>
        </div>
        <Link
          to="/incidents"
          className="inline-flex w-fit items-center gap-1.5 whitespace-nowrap rounded-md border border-foreground-300 px-4 py-2 text-sm text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-700"
        >
          查看全部事件
          <span className="flex h-4 w-4 items-center justify-center">
            <i className="ri-arrow-right-line text-sm"></i>
          </span>
        </Link>
      </div>

      <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-2">
        <article className="group relative overflow-hidden rounded-lg border border-background-200 bg-foreground-950">
          <Link to={`/incident/${featured.id}`} className="block h-full">
            <img
              src={featured.cover}
              alt={`${featured.title} 配图`}
              title={`${featured.title} - 网站黑料重点事件`}
              className="h-72 w-full object-cover object-top opacity-80 transition-transform duration-500 group-hover:scale-[1.03] lg:h-[420px]"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/45 to-transparent"></div>
            <div className="absolute inset-x-0 bottom-0 p-5 md:p-7">
              <div className="flex flex-wrap items-center gap-2">
                <RiskBadge level={featured.riskLevel} size="sm" />
                <span className="rounded-full bg-background-50/15 px-2 py-0.5 text-[11px] text-background-100 backdrop-blur">
                  重点关注
                </span>
                <span className="text-xs text-background-300">{featured.date}</span>
              </div>
              <h3 className="mt-3 font-heading text-xl font-bold leading-snug text-background-50 md:text-2xl">
                {featured.title}
              </h3>
              <p className="mt-2 line-clamp-2 text-sm leading-6 text-background-200">
                {featured.summary}
              </p>
              <span className="mt-4 inline-flex items-center gap-1.5 text-sm text-accent-300">
                阅读完整分析
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-arrow-right-line text-sm"></i>
                </span>
              </span>
            </div>
          </Link>
        </article>

        <div className="flex flex-col gap-4">
          {others.map((incident) => (
            <IncidentCard key={incident.id} incident={incident} layout="horizontal" />
          ))}
        </div>
      </div>
    </section>
  );
}